import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { useTranslation } from 'react-i18next';
import { fetchPagesByFlag } from '../api/pages';
import { LanguageMenu } from './LanguageMenu';
import type { FlaggedPage } from '../api/types';

export function Footer() {
  const { t } = useTranslation();
  const [pages, setPages] = useState<FlaggedPage[]>([]);

  useEffect(() => {
    fetchPagesByFlag('footer')
      .then(setPages)
      .catch(() => setPages([]));
  }, []);

  return (
    <Box component="footer" sx={{ bgcolor: 'grey.900', color: 'common.white', py: 4, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack direction="row" spacing={3} flexWrap="wrap" useFlexGap justifyContent="center">
            {pages.map((page) => (
              <Link
                key={page.slug}
                component={RouterLink}
                to={`/${page.slug}`}
                color="inherit"
                underline="hover"
              >
                {page.title}
              </Link>
            ))}
          </Stack>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems="center"
          >
            <LanguageMenu sx={{ '&:hover': { bgcolor: 'grey.800' } }} />
            <Stack direction="row" spacing={1}>
              <IconButton href="#" color="inherit"><FacebookIcon /></IconButton>
              <IconButton href="#" color="inherit"><InstagramIcon /></IconButton>
              <IconButton href="#" color="inherit"><XIcon /></IconButton>
              <IconButton href="#" color="inherit"><YouTubeIcon /></IconButton>
            </Stack>
          </Stack>
        </Stack>
        <Divider sx={{ my: 2, borderColor: 'grey.700' }} />
        <Typography variant="body2" align="center">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </Typography>
      </Container>
    </Box>
  );
}
